// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"help-rectangle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V21H3V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21V21H3V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12.0002 14.5V14.25C12.0002 13.1454 12.9877 12.2914 13.8553 11.6078C14.5525 11.0585 15.0002 10.2065 15.0002 9.25C15.0002 7.59315 13.657 6.25 12.0002 6.25C10.694 6.25 9.58273 7.08481 9.1709 8.25M12 17.5H12.0039V17.5039H12V17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HelpRectangleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'help-rectangle',
    ref,
    icon: element,
  },
));

HelpRectangleIcon.displayName = 'HelpRectangleIcon';

export default HelpRectangleIcon;
